var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.serverTime)?_c('v-flex',{staticClass:"pr-2 ml-2",attrs:{"shrink":""}},[_c('div',{staticClass:"text-body-1 font-weight-light"},[_vm._v(" UTC: "+_vm._s(_vm.formatedDate)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }